import * as React from 'react';
import {connect} from 'react-redux';

class SimpleInputAgGridRenderer extends React.Component{

  render(){
    const {column,finStrIndex,dealroomFinSchemaErrors} = this.props;
    return(
      <div style={{position: 'relative'}}>
        <p>{this.props.value}</p>
        <p style={{
          position: 'absolute',
          top: '0',
          left: '-10px',
          color: 'red'
        }}>
          {dealroomFinSchemaErrors && dealroomFinSchemaErrors[finStrIndex] && dealroomFinSchemaErrors[finStrIndex][column.colId]}
        </p>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    dealroomFinSchemaErrors: state.financicalSchemas.dealroomFinSchemaErrors,
  }
};
export default connect(mapStateToProps)(SimpleInputAgGridRenderer);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomFinStr/SimpleInputAgGridRenderer.js